module.exports = __webpack_public_path__ + "static/media/choose-plan-multi-company-rsm.2ed0d13c.svg";